import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { PASSWORD_REQUIREMENTS } from '../utils/passwordPolicy';

interface PasswordRequirementsChecklistProps {
  password: string;
}

/**
 * Elenco live dei requisiti della password, con spunta verde/grigia che si
 * aggiorna ad ogni carattere digitato. Va mostrato ovunque l'utente imposti
 * o cambi una password (invito, reset, cambio password).
 */
export const PasswordRequirementsChecklist: React.FC<PasswordRequirementsChecklistProps> = ({
  password,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 0.5, mb: 1 }}>
      {PASSWORD_REQUIREMENTS.map(req => {
        const satisfied = req.test(password);
        return (
          <Box key={req.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {satisfied ? (
              <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />
            ) : (
              <CancelIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
            )}
            <Typography
              variant="caption"
              sx={{ color: satisfied ? 'success.main' : 'text.secondary' }}
            >
              {req.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PasswordRequirementsChecklist;
